import styled from 'styled-components'
import { Box } from './box'
import {
    BsTwitterX,
    BsGithub,
    BsLinkedin,
    BsWordpress,
} from "react-icons/bs";


const RSSButtons = styled(Box)`
    color: ${ props => props.theme.colors.black };
    flex-direction: row;

    @media print {
        display: none;
    }

    a {
        cursor: pointer;
        border-radius: 50%;
    }

    :hover {
        color: ${ props => props.theme.colors.main };
    }
`

export const RRSS = () => <RSSButtons row>
    <a href="https://prdeving.wordpress.com/" target="blank">
        <BsWordpress size="1.5em"/>
    </a>
    <a href="https://twitter.com/prdeving" target="blank">
        <BsTwitterX size="1.5em"/>
    </a>

    <a href="https://github.com/PRDeving" target="blank">
        <BsGithub size="1.5em"/>
    </a>
    <a href="https://www.linkedin.com/in/pablo-roizo-martinez-a1b176125/" target="blank">
        <BsLinkedin size="1.5em"/>
    </a>
</RSSButtons>

